import { t } from 'i18next'

import GoalCampaignCard from '../../../GoalCampaignCard'
import { ProfitabilityGoalMeta } from '../goalOptions'

export const GoalLabel = ({
  selected,
  goal
}: {
  selected: boolean
  goal: CampaignGoalWithMeta
}) => {
  const observationRaw = (goal?.meta as ProfitabilityGoalMeta)?.observation

  const observation: string | null = observationRaw ? t(observationRaw) : null

  return (
    <GoalCampaignCard
      title={t(goal?.meta?.title)}
      description={t(goal?.meta?.description)}
      observation={observation}
      image={goal?.name}
      recommendedFor={t(goal?.meta?.recommendedFor)}
      adcostObjectiveMin={goal?.range?.min}
      adcostObjectiveMax={goal?.range?.max}
      selected={selected}
    />
  )
}
